// public "Find Your Daisy" state-select buttons + franchise results list.
// the postcode search input on the same page is handled separately by
// postcode-search-widget.js (also shared with the admin franchisee edit form) —
// required here purely for load-order/side-effects, it exposes window.getCsrfToken
require('./postcode-search-widget');

document.addEventListener('DOMContentLoaded', async function () {
    if (typeof franchiseSearchId === 'undefined') return;
    const filterFranchiseSearch = document.getElementById('filter-franchise-search-' + franchiseSearchId);
    if (!filterFranchiseSearch) return;

    const token = window.getCsrfToken();

    const stateSelectRow = document.getElementById('state-select-' + franchiseSearchId);
    const stateButtons = stateSelectRow ? stateSelectRow.querySelectorAll('.state-select-btn') : [];
    if (!stateButtons.length) return;

    const filterMessage = filterFranchiseSearch.querySelector('.franchise-search-message');
    filterMessage.classList.add('d-none');

    const itemsContainer = filterFranchiseSearch.querySelector('.filter-franchise-search-items');

    const ALL = 'ALL';
    let activeState = ALL; // "All" is the default: every state shown, grouped

    // ordered list of real states + their display names, taken straight from the
    // buttons (skip the "All" button — it has no single state to head a group).
    // keeping this in sync with the blade means the group order matches the buttons.
    const stateOrder = [];
    const stateNames = {};
    stateButtons.forEach(btn => {
        if (btn.dataset.state && btn.dataset.state !== ALL) {
            stateOrder.push(btn.dataset.state);
            stateNames[btn.dataset.state] = btn.dataset.stateName || btn.dataset.state;
        }
    });

    // fun fact, our postcodes map to state well
    function postcodeToState(postcode) {
        const pc = parseInt(postcode, 10);

        if (pc >= 200 && pc <= 299) return 'ACT';
        if (pc >= 800 && pc <= 999) return 'NT';
        if (pc >= 1000 && pc <= 2599) return 'NSW';
        if (pc >= 2600 && pc <= 2618) return 'ACT';
        if (pc >= 2619 && pc <= 2898) return 'NSW';
        if (pc >= 2900 && pc <= 2920) return 'ACT';
        if (pc >= 2921 && pc <= 2999) return 'NSW';
        if (pc >= 3000 && pc <= 3999) return 'VIC';
        if (pc >= 4000 && pc <= 4999) return 'QLD';
        if (pc >= 5000 && pc <= 5999) return 'SA';
        if (pc >= 6000 && pc <= 6999) return 'WA';
        if (pc >= 7000 && pc <= 7999) return 'TAS';
        if (pc >= 8000 && pc <= 8999) return 'VIC';
        if (pc >= 9000 && pc <= 9999) return 'QLD';
        // womp
        return null;
    }

    async function fetchSuburbs() {
        const res = await fetch('/componentfranchisesearch/listFranchisesWithSuburb', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-CSRF-TOKEN': token },
            body: JSON.stringify({ _token: token })
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);

        const data = await res.json();
        return Array.isArray(data.result) ? data.result : [];
    }

    // one franchise card: a real link (keyboard focus/nav for free) with the
    // franchise name and, if this franchise runs a wheelchair-accessible vehicle,
    // the WAV icon beside it
    function buildCard(row) {
        const card = document.createElement('div');
        card.className = 'col-md-3 col-sm-6 col-12 p-1 suburb-card';

        const link = document.createElement('a');
        link.className = 'suburb-card-inner px-3 py-1 h-100';
        link.href = window.location.origin + '/franchise/' + row.franchise_url;

        const heading = document.createElement('h5');
        heading.className = 'mb-0';
        heading.textContent = row.franchise_name ?? row.suburb ?? 'Franchise';
        link.appendChild(heading);

        if (row.wav) {
            const wavIcon = document.createElement('img');
            wavIcon.className = 'suburb-card__wav';
            wavIcon.src = window.location.origin + '/images/icons/png/wav-icon.png';
            wavIcon.alt = 'Wheelchair accessible vehicle available';
            wavIcon.title = 'Wheelchair accessible vehicle available';
            link.appendChild(wavIcon);
        }

        card.appendChild(link);
        return card;
    }

    // one state section: a heading followed by that state's franchise cards
    // (alphabetical). data-state lets applyFilter() show/hide the whole group.
    function buildStateGroup(state, rows) {
        const group = document.createElement('div');
        group.className = 'franchise-state-group';
        group.dataset.state = state;

        const daisyIconContainer = document.createElement('div');
        const daisyIcon = document.createElement('img');
        daisyIcon.src = '/images/icons/svg/daisy-icon.svg';
        daisyIconContainer.className = 'franchise-state-group__daisy';
        daisyIconContainer.appendChild(daisyIcon);
        group.appendChild(daisyIconContainer);

        const heading = document.createElement('h3');
        heading.className = 'franchise-state-group__heading text-primary text-uppercase text-center mb-4';
        heading.textContent = stateNames[state] ?? state;
        group.appendChild(heading);

        const cardRow = document.createElement('div');
        cardRow.className = 'row franchise-state-group__cards';
        rows.sort((a, b) => (a.franchise_name ?? '').localeCompare(b.franchise_name ?? ''))
            .forEach(row => cardRow.appendChild(buildCard(row)));
        group.appendChild(cardRow);

        return group;
    }

    // bucket the franchises by state, then render one group per state in button order
    function render(rows) {
        const buckets = {};
        rows.forEach(row => {
            const state = postcodeToState(row.postcode);
            if (!state) return; // unmapped postcode -> not shown in any group
            (buckets[state] = buckets[state] || []).push(row);
        });

        const frag = document.createDocumentFragment();
        stateOrder.forEach(state => {
            if (buckets[state] && buckets[state].length) {
                frag.appendChild(buildStateGroup(state, buckets[state]));
            }
        });
        itemsContainer.insertBefore(frag, filterMessage);
    }

    let stateGroups = [];

    // show every group for "All", otherwise just the selected state's group.
    // surface the empty message only when nothing is visible.
    function applyFilter() {
        let anyVisible = false;
        stateGroups.forEach(group => {
            const show = activeState === ALL || group.dataset.state === activeState;
            group.classList.toggle('d-none', !show);
            if (show) anyVisible = true;
        });
        filterMessage.classList.toggle('d-none', anyVisible);
    }

    // run it! a failed fetch here used to throw uncaught and skip every line below,
    // silently leaving the state buttons with no click handlers at all
    try {
        const rows = await fetchSuburbs();
        render(rows);
    } catch (err) {
        console.error('Error fetching franchise suburbs:', err);
        const messageText = filterMessage.querySelector('p');
        if (messageText) messageText.textContent = 'Something went wrong loading franchise locations. Please refresh the page.';
        filterMessage.classList.remove('d-none');
        return;
    }

    stateGroups = Array.from(itemsContainer.querySelectorAll('.franchise-state-group'));

    function selectState(btn) {
        stateButtons.forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        activeState = btn.dataset.state;
        applyFilter();
    }

    stateButtons.forEach(btn => {
        btn.addEventListener('click', () => selectState(btn));
    });

    // default to "All"
    const defaultButton = Array.from(stateButtons).find(btn => btn.dataset.state === ALL) || stateButtons[0];
    if (defaultButton) selectState(defaultButton);
});
